
import { defineComponent } from 'vue';
import Alert from '~/components/Alerts/Alert.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CurrencyInput from '~/components/Inputs/Currency.vue';
import DepositsTableDialog from '@/components/common/Dialogs/DepositsTableDialog.vue';
import { verifyBankDeposits } from '@/api/account';
import { getError } from '@/utils/error-handler';
import { OnboardingErrors } from '@/interfaces/onboarding';
import { PaymentProviderBankDetails } from '@/interfaces/bank-account';

export default defineComponent({
  name: 'VerifyDepositsAmount',

  components: {
    Alert,
    CustomButton,
    CurrencyInput,
  },

  data: () => ({
    deposits: [] as string[],
    wrongDeposits: [] as string[],
    loading: false,
    validForm: false,
    showDepositsTable: false,
    errorMessage: '',
  }),

  computed: {
    accountLastNumbers() {
      const account = this.$store.getters['PaymentOptions/getBankAccount'] as PaymentProviderBankDetails | null;
      return account?.bank_account_last_4 ?? '';
    },

    buttonDisabled() {
      return this.loading
    || !this.validForm
    || this.deposits.every((val, index) => val === this.wrongDeposits[index]);
    },

    hasVerifiedPaymentMethods() {
      return this.$store.getters['PaymentOptions/hasVerifiedPaymentMethods'];
    }
  },

  methods: {
    showDepositsTableDialog() {
      this.$dialog({ component: DepositsTableDialog });
    },

    async verifyAmounts() {
      this.loading = true;
      try {
        await verifyBankDeposits(this.deposits.map(o => o.toString()));
        this.$emit('success', this.accountLastNumbers);
      } catch (e) {
        this.showDepositsTable = false;
        const error = getError(e);

        if (!error.code) {
          this.errorMessage = 'An unexpected error occurred. Please contact support';
          return;
        }

        switch (error.code) {
          case OnboardingErrors.WRONG_AMOUNTS:
          // eslint-disable-next-line max-len
            this.errorMessage = 'Those amounts appear to be incorrect. Please check the amounts in your bank account and try again.';
            this.wrongDeposits = [...this.deposits];
            this.showDepositsTable = true;
            break;

          case OnboardingErrors.EXCEEDED_LIMIT:
          // Clearing in case there is the residual "Wrong amounts" message
            this.errorMessage = '';
            this.$emit('exceeded-limit');
            break;

          case OnboardingErrors.BANK_LOCKED:
            this.$emit('locked');
            break;

          case OnboardingErrors.ALREADY_VERIFIED:
            this.$router.push({ name: 'home' });
            break;

          case OnboardingErrors.GENERIC:
          default:
            this.errorMessage = error.message;
            break;
        }
      } finally {
        this.loading = false;
      }
    }
  }
});
